import { render, staticRenderFns } from "./resolucion.vue?vue&type=template&id=3bf93df8&scoped=true&"
import script from "./resolucion.vue?vue&type=script&lang=js&"
export * from "./resolucion.vue?vue&type=script&lang=js&"
import style0 from "./resolucion.vue?vue&type=style&index=0&id=3bf93df8&lang=scss&scoped=true&"
import style1 from "./resolucion.vue?vue&type=style&index=1&id=3bf93df8&lang=scss&scoped=true&"
import style2 from "./resolucion.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./resolucion.vue?vue&type=style&index=3&id=3bf93df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf93df8",
  null
  
)

export default component.exports